"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CubicFeetPerMinutePerSquareRootInchOfWaterColumn = exports.LiterPerSecondPerSquareRootPascal = void 0;
var UnitDivide = require("../unit-divide");
var volume_flow_1 = require("./volume-flow");
var square_root_pressure_1 = require("./square-root-pressure");
//VolumeFlowPerSquareRootPressure
exports.LiterPerSecondPerSquareRootPascal = UnitDivide.volumeFlowBySquareRootPressure("LiterPerSecondPerSquareRootPascal", volume_flow_1.LiterPerSecond, square_root_pressure_1.SquareRootPascal);
exports.CubicFeetPerMinutePerSquareRootInchOfWaterColumn = UnitDivide.volumeFlowBySquareRootPressure("CubicFeetPerMinutePerSquareRootInchOfWaterColumn", volume_flow_1.CubicFeetPerMinute, square_root_pressure_1.SquareRootInchOfWaterColumn);
//# sourceMappingURL=volume-flow-per-square-root-pressure.js.map